<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-snackbar
        v-model="messageError.show"
        color="error"
        top
        :timeout="messageError.timeout"
        text-xs-center
      >
        {{ messageError.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>
      <v-snackbar
        v-model="messageSuccess.show"
        color="success"
        top
        :timeout="messageSuccess.timeout"
        text-xs-center
      >
        {{ messageSuccess.message }}
        <v-icon right dark>check</v-icon>
      </v-snackbar>

      <v-flex xs12 md6 class="mt-5" text-xs-center>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Általános adatok</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                name="name"
                label="Név"
                id="name"
                :value="user.name"
                v-model="user.name"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="nickname"
                label="Felhasználónév"
                id="nickname"
                :value="user.nickname"
                v-model="user.nickname"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="email"
                label="Email cím"
                id="email"
                :value="user.email"
                v-model="user.email"
                :rules="[rules.required]"
                disabled
              ></v-text-field>
              <v-text-field
                name="phone"
                label="Telefonszám"
                id="phone"
                :value="user.phone"
                v-model="user.phone"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="country"
                label="Ország"
                id="country"
                :value="user.country"
                v-model="user.country"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="zip"
                label="Irányítószám"
                id="zip"
                :value="user.zip"
                v-model="user.zip"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="city"
                label="Város"
                id="city"
                :value="user.city"
                v-model="user.city"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-text-field
                name="address"
                label="Cím"
                id="address"
                :value="user.address"
                v-model="user.address"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions center>
            <v-btn color="success" @click="setUserNewData()">
              <v-icon dark left>save</v-icon>
              Mentés
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 class="mt-5" text-xs-center>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Jelszó módosítás</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                name="newPassword"
                label="Új jelszó"
                id="newPassword"
                :value="password.new"
                v-model="password.new"
                :rules="[rules.required]"
                :append-icon="
                  password.newShow ? 'visibility' : 'visibility_off'
                "
                :type="password.newShow ? 'text' : 'password'"
                @click:append="password.newShow = !password.newShow"
              ></v-text-field>
              <v-text-field
                name="newPasswordConfirmation"
                label="Új jelszó megerősítése"
                id="newPasswordConfirmation"
                :value="password.confirmation"
                v-model="password.confirmation"
                :rules="[rules.required]"
                :append-icon="
                  password.confirmationShow ? 'visibility' : 'visibility_off'
                "
                :type="password.confirmationShow ? 'text' : 'password'"
                @click:append="
                  password.confirmationShow = !password.confirmationShow
                "
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions center>
            <v-btn color="success" @click="setUserNewPassword()">
              <v-icon dark left>save</v-icon>
              Mentés
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Adatok betöltése folyamatban
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      user: "",
      loader: false,
      messageSuccess: {
        show: false,
        message: "",
        timeout: 4500
      },
      messageError: {
        show: false,
        message: "",
        timeout: 4500
      },
      password: {
        new: "",
        confirmation: "",
        confirmationShow: false,
        newShow: false
      },
      rules: {
        required: value => !!value || "Kötelező"
      }
    };
  },
  methods: {
    getUserData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/user/getData", {
          token: this.$store.getters.getToken
        })
        .then(response => {
          // console.log('settings - resp: ', response.data);
          this.$data.user = response.data.user;

          // var v = this;
          // setTimeout(function () {
          //         v.$data.loader = false;
          //     }, 2000);
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("settings - error: ", error);
          }

          // var v = this;
          // setTimeout(function () {
          //         v.$data.loader = false;
          //     }, 2000);
        });
    },
    setUserNewData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/settings/setNewUserData", {
          token: this.$store.getters.getToken,
          name: this.$data.user.name,
          nickname: this.$data.user.nickname,
          phone: this.$data.user.phone,
          email: this.$data.user.email,
          country: this.$data.user.country,
          zip: this.$data.user.zip,
          city: this.$data.user.city,
          address: this.$data.user.address
        })
        .then(response => {
          // console.log('settings - set - data - resp: ', response.data);
          this.$data.messageSuccess.message = response.data.message;
          this.$data.messageSuccess.show = true;
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('settings - set - data - error: ', error);
            this.$data.messageError.message = error.response.data.message;
            this.$data.messageError.show = true;
          }
        });
    },
    setUserNewPassword() {
      //If password match
      if (this.$data.password.new === this.$data.password.confirmation) {
        if (this.$data.password.new.length >= 6) {
          axios
            .post(
              this.$store.getters.getApiUrl +
                "/api/settings/setNewUserPassword",
              {
                token: this.$store.getters.getToken,
                newPassword: this.$data.password.new
              }
            )
            .then(response => {
              // console.log('settings - set - password - resp: ', response.data);
              this.$data.messageSuccess.message = response.data.message;
              this.$data.messageSuccess.show = true;
            })
            .catch(error => {
              if (error.length > 0) {
                // console.log('settings - set - password - error: ', error);
                this.$data.messageError.message = error.response.data.message;
                this.$data.messageError.show = true;
              }
            });
        } else {
          this.$data.messageError.message =
            "Jelszónak legalább 6 karakternek kell lennie!";
          this.$data.messageError.show = true;
        }
      } else {
        this.$data.messageError.message = "Nem egyező jelszavak!";
        this.$data.messageError.show = true;
      }
    }
  },
  created: function() {
    // this.$data.loader = true; //Show loader
    this.getUserData();
  }
};
</script>
